// extracted by mini-css-extract-plugin
export default {"TablePagination":"styles_TablePagination__lQpxr","sticky":"styles_sticky__oaxAj"};